// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class ContentRactionApi extends MainAPI {
	/** 
	 * @param {*} reactionDetails
	 */
	async getReaction(reactionDetails) {
		return API.get(`${ENDPOINTS.GET_REACTION}?${queryString.stringify(reactionDetails)}`);
	}
}

export default new ContentRactionApi();
